export default [
  {
    path: 'sales',
    name: 'sales',
    component: () =>
      import(/* webpackChunkName: "sales-page" */ '@/views/Sales'),
  },
]
